import { pathOr } from 'ramda'

export const SECTION_TITLES = {
  availability: 'Availability',
  coachingFormat: 'Coaching Format',
  coachAttributes: 'Coach Attributes',
  golferAudience: 'Golfer Audience',
}

export const STATIC_BUNDLES = [
  { id: 'bookOnline', attribute: 'bookable', values: ['true'] },
  { id: 'oneToOne', attribute: 'serviceTypes.services.serviceName', values: ['Individual'] },
  { id: 'group', attribute: 'serviceTypes.services.serviceName', values: ['Group'] },
  { id: 'womenCoaches', attribute: 'gender', values: ['F'] },
  { id: 'pgaMember', attribute: 'memberType', values: ['MB', 'ML', 'OT'] },
  { id: 'adults', attribute: 'serviceTypes.services.serviceName', values: ['Adult', 'Senior'] },
  { id: 'juniors', attribute: 'serviceTypes.services.serviceName', values: ['Youth', 'Teen'] },
]

export const buildBundles = (refinerData) => {
  const experienceTypes = pathOr([], ['Experiences', 'experienceTypes'], refinerData)
  const beginnersOptions = experienceTypes
    .find((et) => et.typeName === 'Getting Started')
    ?.experiences
    ?.map((exp) => exp.experienceName) || []

  const bundles = [...STATIC_BUNDLES]
  if (beginnersOptions.length > 0) {
    bundles.push({
      id: 'beginners',
      attribute: 'experienceTypes.experiences.experienceName',
      values: beginnersOptions,
    })
  }
  return bundles
}

export const valuesForBundle = (bundles, id) => bundles.find((bundle) => bundle.id === id)?.values || []

export const COACHING_FORMAT_OPTIONS = [
  { value: 'Individual', label: '1:1 Lessons' },
  { value: 'Group', label: 'Group Programs' },
]

export const DIRECTORY_REFINER_ATTRIBUTES = [
  'bookable',
  'gender',
  'memberType',
  'serviceTypes.services.serviceName',
  'experienceTypes.experiences.experienceName',
]

export const clearDirectoryRefinements = (searchState = {}) => {
  const nextSearchState = { ...searchState }
  delete nextSearchState.persona
  delete nextSearchState.bookThisWeek

  if (nextSearchState.refinementList) {
    const nextList = { ...nextSearchState.refinementList }
    DIRECTORY_REFINER_ATTRIBUTES.forEach((attribute) => {
      delete nextList[attribute]
    })
    if (Object.keys(nextList).length) nextSearchState.refinementList = nextList
    else delete nextSearchState.refinementList
  }

  if (nextSearchState.toggle) {
    const nextToggle = { ...nextSearchState.toggle }
    delete nextToggle.bookable
    if (Object.keys(nextToggle).length) nextSearchState.toggle = nextToggle
    else delete nextSearchState.toggle
  }

  return nextSearchState
}
